<template>
  <div>
    <new-admin-dashboard v-if="allowedRoles.includes(roleAdmin)" />
  </div>
</template>

<script>
import NewAdminDashboard from './new-admin-dashbord/NewAdminDashbord.vue'

export default {
  components: { NewAdminDashboard },
  data() {
    return {
      roleAdmin: localStorage.getItem('user_role'),
      allowedRoles: [
        'admin',
        'manager',
        'hr',
        'hr-office',
        'process-manager',
        'marketer',
        'engineer-allocation',
        'engineer',
        'office-manager',
        'super-manager',
      ],
    }
  },
}
</script>
